import Header from "../../components/Header";

import "./AboutPage.css";

const AboutPage = (props) => {
  return (
    <div>
      <Header />
      <div className="about-container">
        <section className="about-text">
          Hi, everyone. I'm Misha, I'm 26, from Bulgaria and I'm currently
          enrolled in a coding bootcamp with the University of Birmingham. I
          moved to the UK for uni when I was 19 and I'm somehow still here. I
          studied Interior Design, but never did anything with my degree, other
          than keep it in the envelope it came in. I work as a waitress in a pub
          in Edgbaston. I started working there part-time when I was still in
          university and have now been there for over 3 years! That's a lot of
          pints I've poured and a lot of dogs I've pet!
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
